function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWalletConnect = function SvgWalletConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 17
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#3b99fc",
      fillOpacity: 1
    },
    d: "M5.734 3.332c4.567-4.402 11.965-4.402 16.532 0l.55.527a.552.552 0 0 1 0 .797L20.938 6.47c-.118.11-.301.11-.415 0l-.757-.727c-3.184-3.07-8.348-3.07-11.532 0l-.808.781c-.117.11-.301.11-.414 0l-1.88-1.812a.546.546 0 0 1 0-.797Zm20.418 3.746 1.672 1.613c.23.22.23.579 0 .797l-7.543 7.27a.592.592 0 0 1-.824 0l-5.355-5.16a.146.146 0 0 0-.204 0l-5.355 5.16a.592.592 0 0 1-.824 0L.176 9.488a.546.546 0 0 1 0-.797l1.672-1.613a.605.605 0 0 1 .828 0l5.351 5.16a.151.151 0 0 0 .207 0l5.352-5.16a.605.605 0 0 1 .828 0l5.352 5.16a.151.151 0 0 0 .207 0l5.351-5.16a.605.605 0 0 1 .828 0Zm0 0"
  }));
};
export default SvgWalletConnect;